import { FormActivity } from './form-activity';
import { Activity, ActivityModel, ScreenActivity } from './activity';
import { Utilities, ActivityUtilities } from 'src/app/services';

export class RenewalReviewActivity extends ScreenActivity<ActivityModel> {
  previousActivities: Activity<ActivityModel>[];

  constructor(options?: Partial<RenewalReviewActivity>) {
    super(options);
    this.type = 'renewal-review-activity';
    this.name = 'Renewal Review Activity';
    this.description =
      'Use this activity to set the entry point for the renewable application review process.';

    if (options) {
      Object.assign(this, options);
    }

    if (options) {
      this.model = new ActivityModel(options.model);
    } else {
      this.model = new ActivityModel();
    }

    this.model.screenName =
      this.model.screenName || 'Review Renewable Application';

    if (this.previousActivities) {
      const aObjs = ActivityUtilities.convertActivitiesJsonToClasses(
        this.previousActivities
      );
      const activities: Activity<ActivityModel>[] = [];

      for (const a in aObjs) {
        activities.push(aObjs[a]);
      }
      this.previousActivities = activities;
    }
  }
}
